"use client";
import { useEffect, useRef } from "react";
import { useConsent } from "./privacy/ConsentRuntime";
import { classifyAiReferrer } from "@/lib/search-discovery/ai-referrals/classification";

const documentEvents = new Map();

export default function AiReferralTracker({ articleId, edition = "" }) {
  const { contract, analyticsCollectionEnabled, canTrackAnalytics } = useConsent();
  const landing = useRef(null);
  const sent = useRef(false);
  useEffect(() => {
    // Capture once for the original document landing, never subsequent SPA articles.
    const navigation = performance.getEntriesByType("navigation")[0];
    if (!navigation || new URL(navigation.name).pathname !== location.pathname) return;
    const key = edition + ":" + articleId;
    if (!landing.current) {
      if (!documentEvents.has(key)) documentEvents.set(key, { articleId, path: location.pathname, referrer: document.referrer, eventId: crypto.randomUUID(), occurredAt: new Date().toISOString() });
      landing.current = documentEvents.get(key);
    }
    if (!analyticsCollectionEnabled || !contract.analyticsAllowed || !canTrackAnalytics?.() || sent.current || landing.current.articleId !== articleId || landing.current.path !== location.pathname || !classifyAiReferrer(landing.current.referrer)) return;
    const controller = new AbortController();
    const send = () => {
      if (document.visibilityState !== "visible" || sent.current || !canTrackAnalytics()) return;
      sent.current = true;
      fetch("/api/ai-referrals" + (edition ? "?edition=" + encodeURIComponent(edition) : ""), {
        method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(landing.current), signal: controller.signal
      }).catch(() => {});
    };
    const check = () => { if (!canTrackAnalytics()) controller.abort(); };
    // Cookie changes in another tab are rechecked before sending and on focus.
    // Aborting is best effort: an already-authorized server transaction may finish.
    window.addEventListener("surgedome:consent-changed", check);
    window.addEventListener("focus", check);
    send(); document.addEventListener("visibilitychange", send);
    return () => { controller.abort(); document.removeEventListener("visibilitychange", send); window.removeEventListener("surgedome:consent-changed", check); window.removeEventListener("focus", check); };
  }, [articleId, edition, contract.analyticsAllowed, analyticsCollectionEnabled, canTrackAnalytics]);
  return null;
}
